"use client";

import dynamic from "next/dynamic";

/** Lazy bundle: TipTap, EditScreen (react-rnd), FFmpeg pipeline — loaded only when the dialog is mounted. */
const CreateNewPostDialog = dynamic(() => import("./CreateNewPost"), {
  ssr: false,
  loading: () => null,
});

export default CreateNewPostDialog;
